// extracted by mini-css-extract-plugin
module.exports = {"html-text":"styles__html-text__2Aq_h","htmlText":"styles__html-text__2Aq_h"};